import { api } from '../utils/api';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { salvarFeatureFlag } from '../actions/pedidoActions';

async function getToken() {
  return fetch(`${process.env.REACT_APP_API_URL}/auth/token`, {
    method: 'POST',
  })
    .then((response) => response.json())
    .then(({ access_token }) => {
      localStorage.setItem('token', access_token);
      return access_token;
    })
    .catch((error) => {
      console.log('error', error);
      return null;
    });
}

export const useFetchExperimento = () => {
  const [token, setToken] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch()
  const featureFlag = useSelector((state) => state?.pedido?.featureFlag)

  useEffect(() => {
    setToken(localStorage.getItem('token'));
  }, []);

  const requestUnleash = useCallback(async (retry = 5, bearerToken = "") => {
    if(retry === 0) return;

    try {
      const response = await api.get('', {
        headers: {
          Authorization: bearerToken,
          token: bearerToken,
        },
      })

      return response;
    } catch (error) {
      const temp = await getToken()
      setToken(temp)

      return requestUnleash(retry - 1, temp);
    }
  }, [])

  const saveRequest = useCallback(async () => {
    try {
      setIsLoading(true)
      // const feature = await requestUnleash()
      // if(!feature) return;

      // const ativation = feature?.data?.toggles?.[0]
      // if(!ativation) return;

      dispatch(salvarFeatureFlag({
        enabled: true,
      }))
    } catch (error) {
      console.log(`error:::`, error);
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    saveRequest()
  }, [saveRequest])
  return {feature: featureFlag, isLoading}
};
